<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__title">
      Формат электронного документа, в который осуществляется конвертация
    </div>

    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="$v.fileFormat.$model"
              label="Формат электронного документа, в который осуществляется конвертация"
              outlined
              :errorMessages="getValidationErrorText($v.fileFormat)"
              :items="formats"
              :filter="filterFormats"
              :loading="false"
              disabled
            />
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import Footer from '@/components/services/elements/Footer';
import { checkInvalid, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import { StepDirection, StepName } from '@/types/services';
import { DocumentConversionStep } from '@/constants';

export default {
  name: 'DocumentConversionDetails',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    fileFormat: 'pdf',
    formats: ['pdf', 'doc', 'txt'],
  }),
  validations: {
    fileFormat: {
      required,
      maxLength: maxLength(255),
      EMOJI,
    },
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    filterFormats(item, queryText) {
      return (
        item.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },

    prefillDraft() {
      if (!ServicesModule.statement.documentConversionDetails) {
        return;
      }

      this.fileFormat =
        ServicesModule.statement.documentConversionDetails.fileFormat;
    },

    assemblyModel() {
      return {
        fileFormat: this.fileFormat,
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: DocumentConversionStep.DOCUMENT_CONVERSION_DETAILS,
      });
    },
  },
};
</script>
